<template>
  <div class="site-selector-container" v-bind:class="{noheader:noheader}">
    <div class="custom-tab">
      <div class="custom-tab-body">
        <b-row>
          <b-col class="flex-column groups-column">
            <div class="selector-title p-2">
              By groups
            </div>
            <div class="groups-wrapper px-2">
              <b-form-group>
                <b-form-checkbox stacked v-for="(group) in groups" class="group-name darkbg" size="sm" :key="group.groupID" :checked="group.isSelected" @change="selectGroup(group,$event) ">{{group.name}}</b-form-checkbox>
              </b-form-group>
            </div>
          </b-col>
          <b-col class="flex-column sites-column">
            <div class="site-options-cont">
                <div class="selector-title pr-3">
                  By groups
                </div>
              <div class="relative search-input-container">
                <b-input v-model="searchText" class="mb-2 mr-sm-2 mb-sm-0 search-input" id="search_text" type="text" placeholder="Search sites" />
                <div class="search-icon-container">
                  <magnifier-icon class="icon-default search-icon"></magnifier-icon>
                </div>
              </div>
              <div class="selector-title pl-3">Select:
                <a @click="selectAll()">All</a>
                <a @click="selectInvert()">Invert</a>
                <a @click="selectNone()">None</a>
              </div>
            </div>
            <div class="sites-wrapper px-2">
              <spinner size="small" v-if="spinner" ></spinner>
              <b-form-group>
                <b-form-checkbox-group id="checkboxes2" name="flavour2" size="sm" v-model="selectedSiteIds">
                  <b-form-checkbox class="site-name-cont blue-checked darkbg"  v-for="(site) in sites" :key="site.siteID" :value="site.siteID" :title="site.name">
                    <b-img-lazy class="favicon-img" :src="appInfo.APP_URL_V2+site.favicon" />
                    <span class="site-name" :title="site.name">
                      {{site.name}}
                    </span>
                  </b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import MagnifierIcon from '../../assets/lens.svg';
import _ from 'lodash';
export default {
  name: 'siteselector',
  components: {
    MagnifierIcon
  },
  props: ['selected', 'noheader'],
  data() {
    return {
      serverURL: window.serverURL,
      searchText: '',
      selectedSiteIds: [],
      selectedGroups: [],
      sites: [],
      groups: [],
      spinner: true
    };
  },
  mounted() {
    this.selectedSiteIds = this.selected;
    setTimeout(()=>{
      this.initSites();
      this.initGroups();
      this.spinner = false;
    });
    
  },
  computed: {
    appInfo() {
      return this.$store.getters.getAppInfo;
    },
  },
  watch: {
    selectedSiteIds(updatedValue) {
      this.$emit('update:selected', updatedValue);
      // 
    },
    selected(newValue) {
      this.selectedSiteIds = this.selected;
      
    },
    searchText(){
      this.initSites();
    }
  },
  methods: {
    initSites() {
      let allSites = this.$store.getters.getSites;
      let filtered = _.filter(allSites, site => {
        return (
          site.name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1
        );
      });
      this.sites = _.sortBy(filtered, [data => data.name.toLowerCase()]);
    },
    initGroups() {
      let allGroups = this.$store.getters.getGroups;
      this.groups = _.sortBy(allGroups, [data => data.name.toLowerCase()]);
    },
    selectAll() {
      this.selectedSiteIds = _.map(this.sites, site => {
        return site.siteID;
      });
    },
    selectInvert() {
      let tempArray = [];
      _.each(this.sites, site => {
        if (this.selectedSiteIds.indexOf(site.siteID) === -1) {
          tempArray.push(site.siteID);
        }
      });
      this.selectedSiteIds = tempArray;
    },
    selectNone() {
      this.selectedSiteIds = [];
    },
    selectGroup(group, isSelected) {
      _.each(this.sites, site => {
        if (site.groupIDs) {
          let index = site.groupIDs.indexOf(group.groupID);
          if (index > -1) {
            if (isSelected) {
              this.selectedSiteIds.push(site.siteID);
            } else {
              this.selectedSiteIds.splice(index, 1);
            }
          }
        }
      });
    }
  }
};
</script>

<style>
</style>
